export default {
  header: {
    title: '💛 Tip the team',
    subtitle: '100% goes to the crew',
  },
  buttons: {
    other: 'Other',
    none: 'None',
  },
  summary_label: 'Tip',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} is the max tip value',
      },
    },
  },
};
